import "layouts/Home/Home.css";
import React from "react";
import {request} from "../../../api-client";
import "./NavBar.css";
import Close from "@material-ui/icons/Close";
import Search from "@material-ui/icons/Search";
import PlayArrow from "@material-ui/icons/PlayArrow";
import IconButton from "@material-ui/core/IconButton";
import {Link} from "react-router-dom";
import Logo from "../../../assets/img/logo-black.png";
import LogoWhite from "../../../assets/img/logo-white.png";
import TextField from "@material-ui/core/TextField/TextField";
import localization from "../../../config/localization";
import {
  getMostImportantAlbum,
  makeUrlImageFromAlbums,
  makeWaveformUrl,
  pushIfDoesNotExist
} from "../../../utils";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import {
  getRefreshToken, getSignatureTime,
  getStoredUser,
  userCanDownloadTracks,
  userisMultiClient,
  userIsSupervisor,
  userIsSysAdmin,
  homePathGenerator,
  addHttpsToUrl,
  slugify, GAevent, getActiveSection
} from "../../../api-client/core/authentication/utils";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Popper from "@material-ui/core/Popper";
import Grow from "@material-ui/core/Grow";
import GlobalSoundBar from "../../../sound-bar/GlobalSoundBar";
import GlobalConfirmationDialog from "../../../components/Letflow/Dialog/GlobalConfirmationDialog";
import analyticsInstance from "../../../analytics/analyticsInstance";
import ContentCreationPlayer from "../../../components/Letflow/ContentCreationPlayer";
import {makeImageUrlWithSize} from "../HomeElements/utils";
import browserHistory from "../../../utils/browserHistory";
import MenuIcon from "@material-ui/icons/Menu";
import Drawer from "@material-ui/core/Drawer";
import { Tooltip, withStyles } from "@material-ui/core";
import moment from "moment";
import UpgradeModal from "../TalentProfile/UpgradeModal";
import FreshChat from "../../../utils/FreshChat";
import { ChatOutlined, ExitToApp, List, PersonOutline, ShareOutlined, Dashboard } from "@material-ui/icons";
import ShareOnSocials from "../../../components/Letflow/ShareOnSocials";
import Video from "../../../assets/img/Letflow/SmartSearch/video.jpeg";
import AudioImage from "../../../assets/img/Letflow/SmartSearch/audio.png";
import Pdf from "../../../assets/img/Letflow/SmartSearch/pdf.jpeg";
import NoImage from "../../../assets/img/no_image.png";
import {makeImageCarousel} from "../HomeElements/HomeElementCarouselItem";
import {ReactComponent as Star} from "../../../components/Letflow/SvgIcons/star.svg"
import availableLanguages from '../../../config/localization/availableLanguages.json'

const ProfileMenuItem = withStyles({
  root: {
    fontSize: "14px",
    justifyContent: "flex-end",
    paddingBottom: "0px",
    paddingTop: "0px",
    paddingRight: "40px",
  },
})(MenuItem);

class homeNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebar: false,
      search: false,
      showSearchItems: false,
      searchInput: null,
      open: false,
      openNotification: false,
      countPendingReceipt: 0,
      conversationsWithUnreadMessages: 0,
      language: localStorage.getItem("default_language"),
      width: window.innerWidth,
      showCreationDialog: false,
      navbarElements: props.navbarElements,
      showShareDialog: false,
      sidebarElements: [
        [
          {title: "navbar_sidebar.my_favorites", isPremium: false, link: homePathGenerator('favoritos')},
          {title: "navbar_sidebar.my_lists", isPremium: false, link: homePathGenerator('mi-lista')},
          {title: "navbar_sidebar.my_projects", isPremium: true, available: true, link: homePathGenerator('projects') },
          {title: "navbar_sidebar.smart_drive", isPremium: true, available: true, link: homePathGenerator('drive')},
          {title: "navbar_sidebar.smart_reels", isPremium: true, available: true, link: homePathGenerator('reels')},
          {title: "navbar_sidebar.smart_share", isPremium: true, available: true, link: homePathGenerator('links')},
        ],
        [
          {title: "navbar_sidebar.profile", Logo: PersonOutline, link: homePathGenerator('mi-perfil')},
          {title: "share", Logo: ShareOutlined, secondary: true, tooltip: localization.get("talent.invisible_profile"), isDisabled: () => getStoredUser().contentCreator == null || !getStoredUser().contentCreator.active, onClick: () => request.contentCreator.share(getStoredUser().contentCreator.id).then(response => this.setState({ showShareDialog: true, shareToken: response.code }))},
          {title: "navbar_sidebar.support", Logo: ChatOutlined, secondary: true, onClick: () => FreshChat.open()},
          {title: "navbar_sidebar.sign_out", Logo: ExitToApp, secondary: true, onClick: () => request.authentication.logout()},
        ]
      ],
      openUpgradeModal: false,
      showLiveButton: false,
      livestreamData: null,
      makeLivestreamCheckRequest: true,
      shareToken: "",
    };
  }

  componentDidMount = () => {
    window.addEventListener('resize', this.setWindowsWidth);
    this.checkForLiveEvents()
    this.checkForLiveEventsTimeout = setInterval(
      () => this.checkForLiveEvents(),
      180000
    );
  };

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.setWindowsWidth)
    clearInterval(this.checkForLiveEventsTimeout);
  };

  setWindowsWidth = () => this.setState({width: window.innerWidth});

  checkForLiveEvents = () => {
    if (this.state.makeLivestreamCheckRequest) {
      request.liveStream.checkIfActive()
        .then(livestreams => {
          if (livestreams.length > 0) {
            this.setState({livestreamData: livestreams[0]})
          } else {
            this.setState({livestreamData: null})
          }
        })
        .then(() => {
          if (this.state.livestreamData) {
            let timeDiffToEnd = moment.utc(this.state.livestreamData.end_time).diff(moment().local(), "seconds")
            this.setState({makeLivestreamCheckRequest: false},
              () => setTimeout(() => this.setState({makeLivestreamCheckRequest: true}), Math.abs(timeDiffToEnd*1000)))

            if (this.state.livestreamData.fake) {
              this.setState({showLiveButton: true})
            } else {
              let timeDiff = moment().diff(moment.utc(this.state.livestreamData.start_time).local(), "seconds")
              if (timeDiff < 0 ) {
                setTimeout(() => this.setState({showLiveButton: true}), Math.abs(timeDiff*1000))
              } else {
                this.setState({showLiveButton: true})
              }
            }
          }
        })
    }
  }

  toggleSearch = open => {

    if (this.state.currentPlayingContent && this.state.currentPlayingContent.id) {
      return;
    }
    this.setState({ search: open }, () => setTimeout(() => this.setState({showSearchItems: open}), 200));
    if (open) {
      setTimeout(() => this.searchInput.focus(), 300);
    } else {
      this.setState({
        searchInput: "",
        savedQueries: [],
        searchResultComponents: [],
        showSearchItems: false,
      });
    }
  };

  handleSearchInputOnChange = e => this.setState({ searchInput: e.target.value }, this.handleSearchInputKeyPress);

  handleSearchInputKeyPress = () => {
    this.interval && clearInterval(this.interval)

      this.interval = setTimeout(() => {
        if (this.state.searchInput.length > 2) {
          this.handleSearch(this.state.searchInput);
          analyticsInstance.navSearch(this.state.searchInput);
        }else {
          this.setState({
            playlists: [],
            contentCreators: [],
            contentCreations: [],
            reelFiles: [],
            driveFiles: [],
            searchResultComponents: [],
          })
        }
      }, 200)
  };

  handleSearch = query => {
    GAevent('Search', 'Lupa', query.toLowerCase())

    request.user.globalSearch(query)
      .then((response) => {
        const creations = response.contentCreations || [];
        let contentCreationCreatorTypes = [];
        creations.forEach(contentCreation => pushIfDoesNotExist(contentCreationCreatorTypes, contentCreation.contentCreator.type));
        let playerCreations = [];
        contentCreationCreatorTypes.forEach(creatorType => playerCreations = playerCreations.concat(creations.filter(c => c.contentCreator.type.id === creatorType.id)));
        this.setState({
          playlists: response.playlists || [],
          contentCreators: response.contentCreators || [],
          contentCreations: creations || [],
          reelFiles: response.reel_files || [],
          driveFiles: response.drive_files || [],
          playerCreations: playerCreations
        })
      })
      .then(() => this.appendSearchResult())
  };

  handleToggle = () => {
    this.setState({ open: !this.state.open, openNotification: false });
  };

  handleClose = event => {
    if (this.anchorEl.contains(event.target)) {
      return;
    }
    this.setState({ open: false });
  };

  handlePlayButtonPress = (track, tracks, type, trackContainer) => {
    const soundbarCompatibleTracks = tracks.map(track => {
      const onToggleFavorite = favorite => request.musicFavorite[favorite ? "add" : "remove"](track.id);
      GAevent('Contenido', "Play_Audio", track.title)

      return {
        fetchAudioUrl: () => new Promise(resolve => {
          let url = '';
          const date = new Date()
          const now_utc = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

          if((now_utc - Date.parse(track.time)) < getSignatureTime()) {
            url = track.audio.url
          }else{
            url = request.music.getForClient(track.id).then(track => track.audio.url)
          }

          resolve(url);
        }),
        id: track.id,
        title: track.title,
        subtitle: trackContainer && (trackContainer.title ? trackContainer.title : trackContainer.name ? trackContainer.name : undefined),
        image: this.makeSoundbarTrackImage(trackContainer),
        waveform: makeWaveformUrl(track),
        onDownload: userCanDownloadTracks() ? () => this.openDownloadDialog(track, trackContainer, type) : undefined,
        onTitleClick:
          type === "music"
            ? () => this.props.history.push(homePathGenerator(`musica/${track.id}-${slugify(track.title)}`))
            : undefined,
        onSubtitleClick: () => this.handleTrackContainerPressedInSoundbar(trackContainer, type),
        isFavorite: track.favorite,
        onToggleFavorite: type === "music" && onToggleFavorite,
      };
    });
    const playableTrackIndex = tracks.indexOf(track);

    GlobalSoundBar.loadTracksAndPlay(soundbarCompatibleTracks, playableTrackIndex);
  };

  addTrackContainer = (track, tracks, type) => {
    const audioRequest = type === 'voice' ? request.voice.get(track.id) : request.music.getForClient(track.id)

    audioRequest.then(trackContainer =>
      this.handlePlayButtonPress(
        track,
        tracks,
        type,
        trackContainer.albums
          ? getMostImportantAlbum(trackContainer.albums)
          : trackContainer.speaker
          ? trackContainer.speaker
          : undefined
      )
    )
  };

  playCreation = (creation, index=null) => {
    GAevent('Contenido', creation.audio ? "Play_Audio" : "Play", creation.title)
    if (!index) {
      index = this.state.playerCreations.indexOf(creation);
    }
    let hasPrev = index > 0 ;
    let hasNext = index < (this.state.playerCreations.length - 1);
    return this.setState({currentPlayingContent: null, showContentCreationDialog: true}, () => {
      request.contentCreation.get(creation.id)
      .then(response => this.setState({currentPlayingContent: response, showContentCreationDialog: true, hasPrev: hasPrev, hasNext: hasNext, currentIndex: index}))
      .catch(() => this.setState({currentContentCreation: null, showContentCreationDialog: false}));
    });
  }

  clearCurrentPlayingContent = () => {
    this.setState({showContentCreationDialog: false, hasPrev: false, hasNext: false, currentIndex: null, currentPlayingContent: {}})
  }

  makeSoundbarTrackImage = trackContainer => {
    if (trackContainer.length > 0) {
      return this.makeUrlImageFromAlbums(trackContainer);
    } else {
      return makeImageUrlWithSize(trackContainer, 'xs');
    }
  };

  makeUrlImageFromAlbums = albums => makeUrlImageFromAlbums(albums);

  openDownloadDialog = (track, trackContainer, type) => {
    GlobalConfirmationDialog.show({
      title: localization.get("download.demo"),
      content: localization.get("download.demo.content"),
      request: () => this.handleDownload(track, trackContainer, type),
      confirmationLabel: localization.get("download")
    });
  };

  handleDownload = (track, trackContainer, type) => {
    this.setState({ downloading: true });
    let downloadType = type === "voice" ? "download" : "downloadDemo";
    return request[type][downloadType](track.id, {
      title: track.title,
      image: this.makeSoundbarTrackImage(track, trackContainer)
    })
      .then(() => {
        this.setState({ downloading: false });
      })
      .catch(() => {
        this.setState({ downloading: false });
      });
  };

  handleTrackContainerPressedInSoundbar = (trackContainer, type) => {
    let destinationPath = this.makeTrackContainerPathFrom(trackContainer, type);
    if (destinationPath) {
      this.props.history.push(destinationPath);
    }
  };

  makeTrackContainerPathFrom = (trackContainer, type) => {
    let destinationPath;
    if (trackContainer && type === "music") {
      destinationPath = homePathGenerator(`album/${trackContainer.id}`);
    }
    return destinationPath;
  };

  getNoImage = (creation) => {
    if (!!creation.video) {
      return Video;
    }else if (!!creation.audio) {
      return AudioImage;
    }else if (!!creation.binary) {
      return Pdf;
    }else {
      return NoImage;
    }
  }

  getImage = creation => {
    if (creation.image) {
      return makeImageCarousel(creation);
    } else if (creation.video && creation.video.thumbnail) {
      return makeImageCarousel({image: creation.video.thumbnail});
    }

    return this.getNoImage(creation)
  }

  appendSearchResult = () => {
    const { contentCreators, contentCreations } = this.state;
    const searchResultComponents = [];
    if (contentCreators.length > 0 || contentCreations.length > 0) {
      if (contentCreators.length > 0) {
        const contentCreatorTypes = [];
        contentCreators.forEach(contentCreator => pushIfDoesNotExist(contentCreatorTypes, contentCreator.type));

        contentCreatorTypes.forEach(contentCreatorType => {
          searchResultComponents.push(
            <div className="searchbar-result-row-container">
              <h4>{contentCreatorType.name}</h4>
              {contentCreators.filter(contentCreator => contentCreator.type.id === contentCreatorType.id).map(contentCreator => (
                <Link
                  onClick={() => this.toggleSearch(false)}
                  to={homePathGenerator(`contenido/${contentCreator.id}-${slugify(contentCreator.name)}`)}
                  style={{
                    marginTop: "10px",
                    color: "black",
                    marginBottom: "10px",
                    width: "100%",
                    float: "left",
                    position: "relative",
                    height: "15px"
                  }}
                >
                  <div
                    className="searchbar-result-row-image"
                    style={{backgroundImage: `url(${makeImageUrlWithSize(contentCreator, 'xs')})`}}
                  />
                  <div
                    style={{
                      width: "70%",
                      float: "left",
                      position: "relative",
                      overflow: "hidden",
                      whiteSpace: "nowrap"
                    }}
                  >
                    {contentCreator.name}
                  </div>
                </Link>
              ))}
            </div>
          );
        })
      }
      if (contentCreations.length > 0) {
        const contentCreatorTypes = [];
        contentCreations.forEach(contentCreation => pushIfDoesNotExist(contentCreatorTypes, contentCreation.contentCreator.type));
        contentCreatorTypes.forEach(contentCreatorType => {
          searchResultComponents.push(
            <div className="searchbar-result-row-container">
              <h4>{contentCreatorType.name} ({localization.get('content_creation')})</h4>
              {contentCreations.filter(contentCreation => contentCreation.contentCreator.type.id === contentCreatorType.id).map(contentCreation => (
                <div
                  onClick={() => this.playCreation(contentCreation)}
                  style={{
                    cursor: "pointer",
                    marginTop: "10px",
                    color: "black",
                    marginBottom: "10px",
                    width: "100%",
                    float: "left",
                    position: "relative",
                    height: "15px"
                  }}
                >
                  <div
                    className="searchbar-result-row-image"
                    style={{backgroundImage: `url(${this.getImage(contentCreation)})`}}
                  />
                  <div
                    style={{
                      width: "70%",
                      float: "left",
                      position: "relative",
                      overflow: "hidden",
                      whiteSpace: "nowrap"
                    }}
                  >
                    {contentCreation.title}
                  </div>
                </div>
              ))}
            </div>
          );
        })
      }
    } else {
      searchResultComponents.push(
        <div>
          <p style={{paddingTop: 50, textAlign: "center"}}>{localization.get("searchbar.no_result")}</p>
        </div>
      );
    }
    this.setState({ searchResultComponents: searchResultComponents });
  };

  hasElevatedPrivileges = () => userIsSupervisor() || userIsSysAdmin() || userisMultiClient();

  isSelected = route => {
    if (route === "home") {
      if (window.location.pathname.split("/").length <= 3) {
        return true;
      }
    } else {
      return window.location.pathname.includes(route);
    }
  };

  isProfile = () => {
    return window.location.pathname.includes('mi-perfil');
  }
  
  isMyList = () => {
    return window.location.pathname.includes('mi-lista');
  }
  
  isFavorites = () => {
    return window.location.pathname.includes('favoritos');
  }

  isSmartSearch = () => {
    return window.location.pathname.includes('busqueda-inteligente');
  }

  makeNavbarButton = element => {
    switch (element.data_source) {
      case "my_list":
        return(
          <Link
            className={`channel-navbar-link `}
            to={'#'}
            onClick={e => {
              this.handleNavbarButtonClick()
              e.target.className += "selected-navbar-button"
              GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
              homePathGenerator('mi-lista')
            }}
          >
            {element.title}
          </Link>)
        break;
      case "link":
        return(
          <Link
            className={`channel-navbar-link `}
            to={addHttpsToUrl(element.metadata.link)}
            onClick={e =>{
              e.preventDefault()
              this.handleNavbarButtonClick()
              e.target.className += "selected-navbar-button"
              GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
              window.location.href = addHttpsToUrl(element.metadata.link)
            }}
          >
            {element.title}
          </Link>)
        break;
      case "contact_form":
        return(
          <Link
            className={`channel-navbar-link `}
            to={homePathGenerator(`contacto`)}
            onClick={e => {
              this.handleNavbarButtonClick()
              e.target.className += "selected-navbar-button"
              GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
            }}
          >
            {element.title}
          </Link>)
        break;
      case "home":
        return(
          <Link
            className={`channel-navbar-link `}
            to={homePathGenerator(``)}
            onClick={e => {
              this.handleNavbarButtonClick()
              e.target.className += "selected-navbar-button"
              GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
            }}
          >
            {element.title}
          </Link>)
        break;
      case "content_creator":
        return(
          <Link
            className={`channel-navbar-link `}
            to={homePathGenerator(`browse/${element.id}-${slugify(element.title)}`)}
            onClick={e =>{
              this.handleNavbarButtonClick()
              e.target.className += "selected-navbar-button"
              GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
            }}
          >
            {element.title}
          </Link>)
        break;
      case "catalog" :
        return(
          <Link
            className={`channel-navbar-link `}
            to={homePathGenerator(`browse/${element.id}-${slugify(element.title)}`)}
            onClick={e =>{
              this.handleNavbarButtonClick()
              e.target.className += "selected-navbar-button"
              GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
            }}
          >
            {element.title}
          </Link>)
        break;
      case "video_content_creation":
        return(
          <Link
            className={`channel-navbar-link `}
            to={homePathGenerator(`browse/${element.id}-${slugify(element.title)}`)}
            onClick={e =>{
              this.handleNavbarButtonClick()
              e.target.className += "selected-navbar-button"
              GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
            }}
          >
            {element.title}
          </Link>)
        break;
      case "smart_search":
        return(
          <Link
            className={`channel-navbar-link `}
            to={homePathGenerator(`busqueda-inteligente`)}
            onClick={e =>{
              this.handleNavbarButtonClick()
              e.target.className += "selected-navbar-button"
              GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
            }}
          >
            {element.title}
          </Link>)
        break;
      case "channel_playlist":
        return(
          <Link
            className={`channel-navbar-link `}
            to={homePathGenerator(`browse/${element.id}-${slugify(element.title)}`)}
            onClick={e =>{
              this.handleNavbarButtonClick()
              e.target.className += "selected-navbar-button"
              GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
            }}
          >
            {element.title}
          </Link>)
        break;
      case "drop_down":
        return(
          <div style={{display: "inline-block"}}
               aria-owns={this.state[element.id] ? "menu-list-grow" : null}
               aria-haspopup="true"
               buttonRef={node => {
                 this[element.id] = node;
               }}
          >
            <Link
              className={`channel-navbar-link `}
              to="#"
              onClick={e =>{
                this.handleNavbarButtonClick()
                e.target.className += "selected-navbar-button"
                this.setState({[element.id]: true})
                GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
              }}
            >
              {element.title}
            </Link>
            <Popper open={this.state[element.id]} anchorEl={this[element.id]} transition disablePortal>
              {({TransitionProps, placement}) => (
                <Grow
                  {...TransitionProps}
                  id="menu-list-grow"
                  style={{transformOrigin: placement === "bottom" ? "center top" : "center bottom"}}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={()=> this.setState({[element.id]: false})}>
                      <MenuList>
                        {this.state.navbarElements.filter(subElement => !!subElement.parent && subElement.parent == element.id).map(subElement =>
                          <MenuItem style={{cursor: "default"}}>
                            {this.makeDropDownButton(subElement)}
                          </MenuItem>
                        )}
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </div>)
        break;
    }
  }

  makeDropDownButton = (element, className = "") => {
    switch (element.data_source) {
      case "link":
        return (
          <Link
            className={`${className} drop-down-link `}
            to={addHttpsToUrl(element.metadata.link)}
            onClick={e => {
              e.preventDefault()
              this.setState({[element.parent]: false})

              if(className !== "") this.setState({sidebar: false})
              GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
              window.location.href = addHttpsToUrl(element.metadata.link)
            }}
          >
            {element.title}
          </Link>)
        break;
      case "contact_form":
        return (
          <Link
            className={`${className} drop-down-link `}
            to={homePathGenerator(`contacto`)}
            onClick={e => {
              this.setState({[element.parent]: false})
              if(className !== "") this.setState({sidebar: false})
              GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
            }}
          >
            {element.title}
          </Link>)
        break;
      case "home":
        return (
          <Link
            className={`${className} drop-down-link `}
            to={homePathGenerator(``)}
            onClick={e => {
              this.setState({[element.parent]: false})
              if(className !== "") this.setState({sidebar: false})
              GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
            }}
          >
            {element.title}
          </Link>)
        break;
      case "content_creator":
        return (
          <Link
            className={`${className} drop-down-link `}
            to={homePathGenerator(`browse/${element.id}-${slugify(element.title)}`)}
            onClick={e => {
              this.setState({[element.parent]: false})
              if(className !== "") this.setState({sidebar: false})
              GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
            }}
          >
            {element.title}
          </Link>)
        break;
      case "catalog" :
        return (
          <Link
            className={`${className} drop-down-link `}
            to={homePathGenerator(`browse/${element.id}-${slugify(element.title)}`)}
            onClick={e => {
              this.setState({[element.parent]: false})
              if(className !== "") this.setState({sidebar: false})
              GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
            }}
          >
            {element.title}
          </Link>)
        break;
      case "video_content_creation":
        return (
          <Link
            className={`${className} drop-down-link `}
            to={homePathGenerator(`browse/${element.id}-${slugify(element.title)}`)}
            onClick={e => {
              this.setState({[element.parent]: false})
              if(className !== "") this.setState({sidebar: false})
              GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
            }}
          >
            {element.title}
          </Link>)
        break;
      case "smart_search":
        return (
          <Link
            className={`${className} drop-down-link `}
            to={homePathGenerator(`busqueda-inteligente`)}
            onClick={e => {
              this.setState({[element.parent]: false})
              if(className !== "") this.setState({sidebar: false})
              GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
            }}
          >
            {element.title}
          </Link>)
        break;
      case "channel_playlist":
        return (
          <Link
            className={`${className} drop-down-link `}
            to={homePathGenerator(`browse/${element.id}-${slugify(element.title)}`)}
            onClick={e => {
              this.setState({[element.parent]: false})
              if(className !== "") this.setState({sidebar: false})
              GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
            }}
          >
            {element.title}
          </Link>)
        break;
    }
  }

  handleNavbarButtonClick = () => {
    let elems = document.querySelectorAll(".channel-navbar-link.selected-navbar-button");

    [].forEach.call(elems, function(el) {
      el.className = el.className.replace(/\bselected-navbar-button\b/, "");
    });

    let elems2 = document.querySelectorAll(".active");

    [].forEach.call(elems2, function(el) {
      el.className = el.className.replace(/\bactive\b/, "");
    });
  }

  makeSidebarItem = (element, isPro) => (
    <div className={!isPro && element.isPremium  ? "navbar-sidebar-link-disabled-container" : element.secondary ? "navbar-secondary-sidebar-link-container" : "navbar-sidebar-link-container"} style={{paddingBottom: 10}}>
      <div className="navbar-sidebar-link">
        <Link
          to={element.link ? element.link : "#"}
          onClick={e => {
            if (element.isPremium && !isPro) {
              e.preventDefault();
              this.openUpgradeBanner();
            } else if (element.link) {
              this.setState({sidebar: false})
            } else if (element.onClick) {
              element.onClick();
              this.setState({sidebar: false});
            }
          }}>
            {((element.isDisabled && element.isDisabled()) || (!element.link && !element.onClick))
              ?
              <>
                <Tooltip
                  title={element.tooltip ? element.tooltip : localization.get("sidebar.soon")}
                  placement="right"
                >
                  <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    {localization.get(element.title)} {element.Logo && <element.Logo style={{ marginLeft: '5px', fontSize: "inherit" }} />}
                  </div>
                </Tooltip> 
                {element.isPremium && !element.available && <div className="navbar-sidebar-pro-container" style={{textTransform: "uppercase"}}>{localization.get("sidebar.soon")}</div>}
                {element.isPremium && element.available && !isPro && <div className="navbar-sidebar-pro-container" style={{textTransform: "uppercase"}}>PRO</div>}
              </>
              :
              <>
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                  {localization.get(element.title)} {element.Logo && <element.Logo style={{ marginLeft: '5px', fontSize: "inherit" }} />}
                </div>
                {element.isPremium && !element.available && <div className="navbar-sidebar-pro-container" style={{textTransform: "uppercase"}}>{localization.get("sidebar.soon")}</div>}
                {element.isPremium && element.available && !isPro && <div className="navbar-sidebar-pro-container" style={{textTransform: "uppercase"}}>PRO</div>}
              </>
            }
          </Link>
      </div>
    </div>
  )

  makeSidebarButton = element => {
    switch (element.data_source) {
      case "my_list":
        return(
          <div className="navbar-sidebar-link-container"  style={{paddingBottom: 5}}>
            <div className={`navbar-sidebar-link show-link-mobile`}>
              <Link
                to={'#'}
                onClick={() => {
                  GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
                  this.setState({sidebar: false})
                  homePathGenerator('mi-lista')
                }}>{element.title}</Link>
            </div>
          </div>)
        break;
      case "link":
        return(
          <div className="navbar-sidebar-link-container"  style={{paddingBottom: 5}}>
            <div className={`navbar-sidebar-link show-link-mobile`} >
              <Link
                to={addHttpsToUrl(element.metadata.link)}
                onClick={e => {
                  e.preventDefault()
                  this.setState({sidebar: false})
                  GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
                  window.location.href = addHttpsToUrl(element.metadata.link)
                }}>{element.title}</Link>
            </div>
          </div>)
        break;
      case "contact_form":
        return(
          <div className="navbar-sidebar-link-container"  style={{paddingBottom: 5}}>
            <div className={`navbar-sidebar-link show-link-mobile`}>
              <Link
                to={homePathGenerator(`contacto`)}
                onClick={() => {
                  GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
                  this.setState({sidebar: false})
                }}>
                {element.title}
              </Link>
            </div>
          </div>)
        break;
      case "home":
        return(
          <div className="navbar-sidebar-link-container"  style={{paddingBottom: 5}}>
            <div className={`navbar-sidebar-link show-link-mobile`}>
              <Link
                to={homePathGenerator(``)}
                onClick={() => {
                  GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
                  this.setState({sidebar: false})
                }}
              >{element.title}</Link>
            </div>
          </div>)
        break;
      case "content_creator":
        return(
          <div className="navbar-sidebar-link-container"  style={{paddingBottom: 5}}>
            <div className={`navbar-sidebar-link show-link-mobile`}>
              <Link
                to={homePathGenerator(`browse/${element.id}-${slugify(element.title)}`)}
                onClick={() => {
                  GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
                  this.setState({sidebar: false})
                }}
              >
                {element.title}</Link>
            </div>
          </div>)
        break;
      case "catalog" :
        return(
          <div className="navbar-sidebar-link-container"  style={{paddingBottom: 5}}>
            <div className={`navbar-sidebar-link show-link-mobile`}>
              <Link
                to={homePathGenerator(`browse/${element.id}-${slugify(element.title)}`)}
                onClick={() => {
                  GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
                  this.setState({sidebar: false})
                }}
              >
                {element.title}</Link>
            </div>
          </div>)
        break;
      case "video_content_creation":
        return(
          <div className="navbar-sidebar-link-container"  style={{paddingBottom: 5}}>
            <div className={`navbar-sidebar-link show-link-mobile`}>
              <Link
                to={homePathGenerator(`browse/${element.id}-${slugify(element.title)}`)}
                onClick={() => {
                  GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
                  this.setState({sidebar: false})
                }}
              >
                {element.title}
              </Link>
            </div>
          </div>)
        break;
      case "smart_search":
        return(
          <div className="navbar-sidebar-link-container"  style={{paddingBottom: 5}}>
            <div className={`navbar-sidebar-link show-link-mobile`}>
              <Link
                to={homePathGenerator(`busqueda-inteligente`)}
                onClick={() => {
                  GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
                  this.setState({sidebar: false})
                }}
              >
                {element.title}
              </Link>
            </div>
          </div>)
        break;
      case "channel_playlist":
        return(
          <div className="navbar-sidebar-link-container"  style={{paddingBottom: 5}}>
            <div className={`navbar-sidebar-link show-link-mobile`}>
              <Link
                to={homePathGenerator(`browse/${element.id}-${slugify(element.title)}`)}
                onClick={() => {
                  GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
                  this.setState({sidebar: false})
                }}
              >
                {element.title}
              </Link>
            </div>
          </div>)
        break;
      case "drop_down":
        return(
          <div className="navbar-sidebar-link-container"  style={{paddingBottom: 5}}>
            <div className={`navbar-sidebar-link show-link-mobile`}>
              <Link
                to="#"
                onClick={e =>{
                  e.preventDefault()
                  GAevent('Search', "Navbar", element.translations.filter(element=> element.locale == "es").title || element.title)
                  let parent = e.target.parentNode.querySelector('.drop-down-selector')
                  if(parent) {
                    e.target.parentNode.classList.contains("drop-down-selected") ?  e.target.parentNode.classList.remove("drop-down-selected") :  e.target.parentNode.className += " drop-down-selected"
                    parent.classList.contains("drop-down-selector-hidden") ? parent.classList.remove("drop-down-selector-hidden") : parent.className += " drop-down-selector-hidden"
                  }
                }}
              >
                {element.title}
              </Link>
              <div className={"drop-down-selector drop-down-selector-hidden"}>
                {this.state.navbarElements.filter(subElement => !!subElement.parent && subElement.parent == element.id).map(subElement =>
                  this.makeDropDownButton(subElement, "drop-down-option")
                )}
              </div>
            </div>
          </div>
        )
        break;
    }
  }

  changeLang = (lang) => {
    let newLang = lang;
    localStorage.setItem("default_language", newLang)
    localization.setLanguage(newLang)
    request.user.changeLanguage({ language: newLang })
      .finally(() => window.location.reload())
  }

  addFontSpecificClass = (font) => {
    switch (font) {
      case 'roboto-font':
        return "livestream-link-txt-roboto"
      case 'avenir-font':
        return "livestream-link-txt-avenir"
      case 'gotham-font':
        return "livestream-link-txt-gotham"
    }
  }

  renderShareDialog = () => {
    let currentUser = getStoredUser();
    if (!currentUser.contentCreator) {
      return;
    }
    let contentCreator = currentUser.contentCreator;
    return (
      <ShareOnSocials
        show={this.state.showShareDialog}
        handleClose={() => this.setState({showShareDialog: false, shareToken: ""})}
        url={`${window.location.protocol}//${window.location.hostname}/public/content_creators/${this.state.shareToken}`}
        darkMode={true}
        title={localization.get("share_profile")}
        shareToken={this.state.shareToken}
      />
    )
  };


  renderUpgradeModal = () => {
    return this.state.openUpgradeModal && 
      <UpgradeModal 
        onModalEnd={() => this.setState({openUpgradeModal: false})}
        onClose={() => this.setState({openUpgradeModal: false})} 
        open={this.state.openUpgradeModal}
      />
  }
  
  openUpgradeBanner = () => {
    this.setState({openUpgradeModal: true});
  }

  render = () => {
    const { sidebar, search, showSearchItems, open, navbarElements, sidebarElements } = this.state;
    let mobile = this.state.width <= 450;

    let currentUser = getStoredUser();
    let isInvisible = currentUser && currentUser.contentCreator && !currentUser.contentCreator.active;
    let hasCreator = currentUser && currentUser.contentCreator;
    let isPro = currentUser.activeSubscription && currentUser.activeSubscription.plan && currentUser.activeSubscription.plan.level > 1;
    let userImage = currentUser.image ? currentUser.image : (hasCreator && currentUser.contentCreator.image) ? currentUser.contentCreator.image : null;
    
    return (
      <div>
        {this.renderUpgradeModal()}
        {this.renderShareDialog()}
        <ContentCreationPlayer
          show={this.state.showContentCreationDialog}
          onCreatorClick={() => this.setState({showContentCreationDialog: false,currentPlayingContent: {}}, () => this.toggleSearch(false))}
          onNextArrow={this.state.hasNext ? () => this.playCreation(this.state.playerCreations[this.state.currentIndex+1]) : null}
          onPrevArrow={this.state.hasPrev ? () => this.playCreation(this.state.playerCreations[this.state.currentIndex-1]) : null}
          currentContentCreation={this.state.currentPlayingContent}
          handleClose={() => this.clearCurrentPlayingContent()}
        />
        { !this.props.transparentMode ?
          <nav className="channel-navbar">
            <div className="channel-navbar-image-container">
              <div className="channel-menu-container">
                <IconButton onClick={() => this.setState({sidebar: true})} className="navbar-menu-button">
                  <MenuIcon />
                </IconButton>
              </div>
              <Link
                className="channel-navbar-image-container-link"
                onClick={() => {
                  if(getActiveSection()) window.location.href = "/"
                  this.handleNavbarButtonClick()
                }}
                to={"/"}>
                <img className="channel-navbar-image"
                     src={Logo}
                     alt={`Logo Bloomclouds`} />
              </Link>
            </div>

            {!this.isProfile() && 
              <div className="channel-navbar-links" >
                {/*${this.isSelected("home") ? "selected" : ""}*/}
                {navbarElements.filter(element => !element.parent).map(element =>
                  this.makeNavbarButton(element)
                )}
              </div>
            }
            {/*Profile*/}
            {!this.isProfile()
            ?
            <div className="channel-navbar-user-container">
              {!!getRefreshToken() && window.innerWidth > 1050 ?
                <div style={{display: "flex", float: 'right', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', margin: '0 10px'}}>
                  <IconButton
                    buttonRef={node => {
                      this.anchorEl = node;
                    }}
                    aria-owns={open ? "menu-list-grow" : null}
                    aria-haspopup="true"
                    onClick={this.handleToggle}
                    style={{top: isInvisible || !hasCreator ? '-10px' : '-5px', color: 'inherit', width: window.innerWidth < 600 ? 20 : 48}}
                  >
                    <div
                      className="channel-navbar-user-button-image"
                      style={{backgroundImage: `url(${makeImageUrlWithSize({image: userImage}, 'xs')})`}}
                    />
                  </IconButton>
                  {!hasCreator && 
                    <Link
                      className="channel-navbar-invisible-creator-btn"
                      style={{backgroundColor: 'green'}}
                      to={homePathGenerator(`mi-perfil`)}
                    >{localization.get("navbar.profile.create_button")}</Link>
                  }
                  {isInvisible && 
                    <Link
                      className="channel-navbar-invisible-creator-btn"
                      to={homePathGenerator(`mi-perfil`)}
                    >{localization.get("navbar.profile.invisible_button")}</Link>
                  }
                  <Popper open={open} anchorEl={this.anchorEl} transition disablePortal>
                    {({TransitionProps, placement}) => (
                      <Grow
                        {...TransitionProps}
                        id="menu-list-grow"
                        style={{transformOrigin: placement === "bottom" ? "center top" : "center bottom"}}
                      >
                        <Paper>
                          <ClickAwayListener onClickAway={this.handleClose}>
                            <div style={{
                                paddingTop: "10px",
                                paddingBottom: "10px",
                                width: "100%",
                            }}>
                              <div style={{
                                cursor: "default",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                width: "100%",
                                backgroundColor: "#ebeff0",
                                paddingRight: "40px",
                                alignItems: "flex-end"
                              }}>
                                <div><b>{getStoredUser().name}</b></div>
                                <div style={{fontSize: "12px"}}>{isPro ? 'Bloom Pro Plan' : 'Bloom Basic Plan'}</div>
                              </div>
                            </div>
                            <ul style={{marginBlockStart:10, paddingInlineStart: 0, paddingBlockEnd: 30, width: 250}}>
                              <Link
                                style={{color: "black"}}
                                to={homePathGenerator(`mi-perfil`)}
                              >
                                <ProfileMenuItem onClick={this.handleClose} style={{color: "black"}}>
                                  <div style={{display: 'flex', alignItems: 'center'}}>
                                    <PersonOutline style={{fontSize: '16px', marginRight: '10px'}}></PersonOutline>
                                    {localization.get("navbar.my_profile")}
                                  </div>
                                </ProfileMenuItem>
                              </Link>
                              <Link
                                style={{color: "black"}}
                                to={`/panel`}
                              >
                                <ProfileMenuItem onClick={this.handleClose} style={{color: "black"}}>
                                  <div style={{display: 'flex', alignItems: 'center'}}>
                                    <Dashboard style={{fontSize: '16px', marginRight: '10px'}}></Dashboard>
                                    {localization.get("Dashboard")}
                                  </div>
                                </ProfileMenuItem>
                              </Link>
                              <ProfileMenuItem disabled={getStoredUser().contentCreator == null || !getStoredUser().contentCreator.active } onClick={() =>
                                request.contentCreator.share(getStoredUser().contentCreator.id)
                                .then(response => this.setState({ showShareDialog: true, shareToken: response.code }))}><ShareOutlined style={{fontSize: '16px', marginRight: '10px'}}></ShareOutlined>{localization.get("share")}</ProfileMenuItem>
                              <ProfileMenuItem onClick={() => FreshChat.open()}><ChatOutlined style={{fontSize: '16px', marginRight: '10px'}}></ChatOutlined>{localization.get("navbar_sidebar.support")}</ProfileMenuItem>
                              <ProfileMenuItem onClick={() => request.authentication.logout()}><ExitToApp style={{fontSize: '16px', marginRight: '10px'}}></ExitToApp>{localization.get("navbar_sidebar.sign_out")}</ProfileMenuItem>
                            </ul>
                          </ClickAwayListener>
                        </Paper>
                      </Grow>
                    )}
                  </Popper>
                </div>
                : null
              }
              <div className="channel-navbar-buttons-container">
                <div className="channel-navbar-buttons">
                  <IconButton
                    onClick={() => {this.handleNavbarButtonClick(); this.toggleSearch(true)}}
                    className={"channel-navbar-search-button"}
                    style={this.isSmartSearch() ? {color: 'inherit', height: 40, stroke: "black", backgroundColor: "rgba(0, 0, 0, 0.08)", border: "#B8B8B8 2px solid", strokeWidth: "0.5"} : {color: 'inherit', height: 40}}
                  >
                    <Tooltip placement="bottom" title={localization.get("search.content")}>
                      <Search />
                    </Tooltip>
                  </IconButton>
                  {getRefreshToken() && 
                    <>
                      <Link style={{color: "inherit"}} to={homePathGenerator("favoritos")}>
                        <IconButton
                          onClick={() => this.handleNavbarButtonClick()}
                          className={"channel-navbar-search-button"}
                          style={this.isFavorites() ? {color: 'inherit', height: 40, stroke: "black", backgroundColor: "rgba(0, 0, 0, 0.08)", border: "#B8B8B8 2px solid", strokeWidth: "1"} : {color: 'inherit', height: 40, strokeWidth: "0.5"}}
                        >
                          <Tooltip placement="bottom" title={localization.get("my_favorites")}>
                            <Star style={{cursor: "pointer", height: 20,width: 20, marginTop: "-2px", fill: "none", stroke: "black"}}/>
                          </Tooltip>
                        </IconButton>
                      </Link>
                      <Link style={{color: "inherit"}} to={homePathGenerator("mi-lista")}>
                        <IconButton
                          onClick={() => this.handleNavbarButtonClick()}
                          className={"channel-navbar-search-button"}
                          style={this.isMyList() ? {color: 'inherit', height: 40, stroke: "black", backgroundColor: "rgba(0, 0, 0, 0.08)", border: "#B8B8B8 2px solid", strokeWidth: "0.5"} : {color: 'inherit', height: 40}}
                        >
                          <Tooltip placement="bottom" title={localization.get("my_lists")}>
                            <List />
                          </Tooltip>
                        </IconButton>
                      </Link>
                    </>
                  }
                </div>
                {!hasCreator && window.innerWidth <= 1050 &&
                  <Link
                    className="channel-navbar-invisible-creator-btn"
                    style={{backgroundColor: 'green'}}
                    to={homePathGenerator(`mi-perfil`)}
                  >{localization.get("navbar.profile.create_button")}</Link>
                }
                {isInvisible && window.innerWidth <= 1050 &&
                  <Link
                    className="channel-navbar-invisible-creator-btn"
                    to={homePathGenerator(`mi-perfil`)}
                  >{localization.get("navbar.profile.invisible_button")}</Link>
                }
              </div>

              {this.state.livestreamData &&
                <Link
                  id="livestream-link"
                  className={`livestream-link`}
                  to={homePathGenerator(`vivos`)}
                  onClick={() => {
                    this.handleNavbarButtonClick()
                  }}
                  onMouseOut={() => document.getElementById('livestream-link').blur()}
                >
                  <PlayArrow/>
                  <span>
                    {localization.get(this.state.livestreamData.fake ? 'livestream.premiere' : 'on_live')}</span>
                </Link>
              }
            </div>
            :
            <div className="navbar-close-profile-container">
              <Link
                to={homePathGenerator("")}
                class={"navbar-close-profile-link"}
              >
                {localization.get("navbar.close_profile")}
              </Link>
              
              <Link to={homePathGenerator("")} class={"navbar-close-profile-button"}>
                <IconButton>
                  <Close style={{fontSize: '20px'}}/>
                </IconButton>
              </Link>
            </div>
            }
          </nav>
          :
          <nav className="channel-navbar transparent">
            <div className="channel-navbar-image-container">
              <Link className="channel-navbar-image-container-link" to={homePathGenerator(``)}>
                <img className="channel-navbar-image" style={{filter:  "grayscale(1)"}} src={LogoWhite} alt="Logo Bloomclouds" />
              </Link>
            </div>
          </nav>
        }

        <ClickAwayListener onClickAway={() => this.toggleSearch(false)}>
          <div>
            <div style={{ height: search ? "75px" : 0 }} className="search-bar">
              {window.innerWidth > 1050 &&
              <img className="channel-navbar-image-search-bar"
                   style={{display: !search ? "none" : "block", cursor: "pointer"}}
                   onClick={() => {
                     this.toggleSearch(false)
                     this.handleNavbarButtonClick()
                     browserHistory.push(homePathGenerator(``))
                   }}
                   src={Logo}
                   alt={`Logo Bloomclouds`}/>
              }
              {showSearchItems && showSearchItems && window.innerWidth > 850 &&
              <Link
                onClick={() => this.toggleSearch(false)}
                to={homePathGenerator(`busqueda-inteligente`)}
                class={"smart-search-link"}
              >
                {localization.get("go_to.smart_search")}
              </Link>
              }
              <div style={{ display: showSearchItems ? "block" : "none" }} className="channel-navbar-close-search-button-container">

                <IconButton onClick={() => this.toggleSearch(false)} className="channel-navbar-menu-button">
                  <Close />
                </IconButton>
              </div>
              <div style={{ display: showSearchItems ? "inline-block" : "none" }} className="searchbar-input-container">
                <TextField
                  inputProps={{
                    ref: input => {
                      this.searchInput = input;
                    },
                    spellCheck: false
                  }}
                  autoComplete={false}
                  className="searchbar-input"
                  placeholder={localization.get("searchbar.input")}
                  value={this.state.searchInput}
                  onChange={this.handleSearchInputOnChange}
                />
              </div>
            </div>

            <div id="searchbar-results-container" className="searchbar-results-container">
              {showSearchItems && showSearchItems && window.innerWidth < 850 &&
              <Link
                onClick={() => this.toggleSearch(false)}
                to={homePathGenerator(`busqueda-inteligente`)}
                class={"smart-search-link"}
              >
                {localization.get("go_to.smart_search")}
              </Link>
              }
              {this.state.searchResultComponents}
            </div>
          </div>

        </ClickAwayListener>

        <Drawer
          id="navbar-drawer"
          PaperProps={{ style: { backgroundColor: "#ebeff0" } }}
          open={sidebar}
          onClose={() => this.setState({sidebar: false})}
        >
          <div className="navbar-sidebar">
            <div className="navbar-sidebar-header-container" style={{width: "100%", zIndex:100}}>
              <IconButton onClick={() => this.setState({sidebar: false})} className="navbar-sidebar-close-button">
                <Close />
              </IconButton>
              <div className="navbar-sidebar-idiom-container">
                <div
                  style={{
                    fontWeight: this.state.language === "es" ? 'bold' : 'normal',
                    cursor: 'pointer',
                    float: "left",
                    position: "relative",
                    marginRight: "10px"
                  }}
                  onClick={() => {
                    if (this.state.language != "es") {
                      this.changeLang("es");
                    }
                  }}
                >ES</div>
                |
                <div
                  style={{
                    fontWeight: this.state.language === "en" ? 'bold' : 'normal',
                    cursor: 'pointer',
                    float: "left",
                    position: "relative",
                    margin: "0 10px"
                  }}
                  onClick={() => {
                    if (this.state.language != "en") {
                      this.changeLang("en");
                    }
                  }}
                >EN</div>
                |
                <div
                  style={{
                    fontWeight: this.state.language === "pt" ? 'bold' : 'normal',
                    cursor: 'pointer',
                    float: "left",
                    position: "relative",
                    marginLeft: "10px"
                  }}
                  onClick={() => {
                    if (this.state.language != "pt") {
                      this.changeLang("pt");
                    }
                  }}
                >PT</div>
              </div>
            </div>

            <div className="navbar-sidebar-container">
              {navbarElements.filter(element => !element.parent).map(element =>
                this.makeSidebarButton(element)
              )}
              {this.state.livestreamData &&
              <Link
                className={`livestream-link`}
                to={homePathGenerator(`livestream/${this.state.livestreamData.id}`)}
              >
                <PlayArrow/>
                <span style={{position: "absolute", top: 4,left: "45px"}}
                >{localization.get(this.state.livestreamData.fake ? 'livestream.premiere' : 'on_live')}</span>
              </Link>
              }
            </div>

            {sidebarElements.map(set => (
              <div className="navbar-sidebar-container">
                {set.map(element => this.makeSidebarItem(element, isPro))}
              </div>
            ))}
          </div>
        </Drawer>
      </div>
    );
  }
}

homeNavbar.defaultProps = {
  transparentMode: false
};

export default homeNavbar;
